<template>
    <vx-table class="xl:grid-cols-7-auto mb-8" rowBreakpoint="xl">
        <vx-table-row isHeader>
            <div class="lg:pl-6">Phone Number</div>
            <div>Vendor</div>
            <div>Brand</div>
            <div>Brand Trust</div>
            <div>Campaign</div>
            <div>Team</div>
            <div>Synced</div>
        </vx-table-row>

        <slot></slot>
    </vx-table>
</template>

<script lang="ts" setup>
import { VxTable, VxTableRow } from '@voxie/frontend-components';
</script>
